import BaseObject from '../../base/base_object';

export default class GameUrlBuilderBase extends BaseObject {
    init(params) {
        super.init(params);
        if(!params.serviceFactory) {
            this.throwArgumentExpected('7', 'init', 'serviceFactory');
        }

        this.serviceFactory = params.serviceFactory;
    }

    buildRealGameUrl(gameOptions) {
        this.throwNotImplemented('14', 'buildRealGameUrl');
    }

    buildAnonymousGameUrl(gameOptions) {
        this.throwNotImplemented('18', 'buildRealGameUrl');
    }

    buildHistoryGameUrl(gameOptions) {
        this.throwNotImplemented('22', 'buildRealGameUrl');
    }

}